(function(angular) {
    'use strict';
    
    angular.module('shared')
    .controller('CustomErrorCtrl', ['$scope', '$stateParams', '$state', '$window' ,function ($scope, $stateParams, $state, $window) {
        var error = $stateParams.error;
        var errorName = error ? error.error.status : $state.current.name;

        $scope.goBack = function(){
            $window.history.back();
        };
        $scope.refresh = function(){
            $state.go(error.toState.name, error.toParams);
        };

        $scope.errors = {
            accessDenied: {
                label: "Access Denied",
                availableButtons: ['back', 'home']
            },
            custom: {
                label: errorName,
                availableButtons: ['back', 'refresh', 'home']
            }
        };
        $scope.availableButton = function(name){
            return $scope.error.availableButtons.includes(name);
        }
        $scope.error = $scope.errors[errorName] ? $scope.errors[errorName] : $scope.errors.custom;

    }]);

})(window.angular);